import { useTranslation } from "react-i18next";

interface PremiumHeroProps {
  entered: boolean;
}

export default function PremiumHero({ entered }: PremiumHeroProps) {
  const { i18n } = useTranslation();
  const isEn = i18n.language === "en";

  const stats = [
    { icon: "ri-infinity-line", label: isEn ? "Unlimited minutes" : "Minutos ilimitados" },
    { icon: "ri-time-line", label: "SLA 99.9%" },
    { icon: "ri-global-line", label: isEn ? "31 languages" : "31 idiomas" },
    { icon: "ri-database-2-line", label: "CRM Custom" },
  ];

  return (
    <div
      className={`text-center mb-12 transition-all duration-700 ${
        entered ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      }`}
    >
      {/* Icon */}
      <div className="relative inline-flex items-center justify-center mb-6">
        <div className="w-20 h-20 rounded-full bg-amber-50 flex items-center justify-center">
          <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center">
            <i className="ri-vip-crown-2-line text-3xl text-amber-500" />
          </div>
        </div>
        <div className="absolute inset-0 rounded-full border-2 border-amber-300 animate-ping opacity-20" />
      </div>

      {/* Badge */}
      <div className="inline-flex items-center gap-2 px-3 py-1 bg-amber-500 rounded-full mb-4">
        <i className="ri-vip-crown-line text-white text-xs" />
        <span className="text-xs font-bold text-white uppercase tracking-widest">
          {isEn ? "Premium plan activated" : "Plan Premium activado"}
        </span>
      </div>

      {/* Title */}
      <h1
        className="text-4xl lg:text-5xl font-bold text-stone-900 mb-4 leading-tight"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        {isEn ? (
          <>
            Welcome to Auria&apos;s
            <br />
            <span className="text-amber-500">highest tier</span>
          </>
        ) : (
          <>
            Bienvenido al nivel
            <br />
            <span className="text-amber-500">más alto de Auria</span>
          </>
        )}
      </h1>

      {/* Description */}
      <p className="text-stone-500 text-lg max-w-xl mx-auto leading-relaxed mb-5">
        {isEn ? (
          <>
            You have a <strong className="text-stone-700">dedicated account manager</strong>. We handle everything for you — Canvas Memory, CRM, Branded Call ID and call forwarding. Just follow these steps.
          </>
        ) : (
          <>
            Tienes asignado un <strong className="text-stone-700">account manager dedicado</strong>. Nos encargamos de configurarlo todo por ti — Canvas Memory, CRM, Branded Call ID y desvíos. Solo tienes que seguir estos pasos.
          </>
        )}
      </p>

      {/* VIP callout */}
      <div className="inline-flex items-center gap-3 px-5 py-3 bg-amber-50 border border-amber-200 rounded-2xl mb-2">
        <i className="ri-shield-star-line text-amber-500 text-lg" />
        <span className="text-sm text-amber-800 font-semibold">
          {isEn
            ? "Your personalised onboarding begins within the next 2 business hours"
            : "Tu onboarding personalizado comienza en las próximas 2 horas hábiles"}
        </span>
      </div>

      {/* Stats */}
      <div className="inline-flex items-center gap-6 mt-6 px-6 py-3 bg-stone-900 rounded-2xl">
        {stats.map((item) => (
          <div key={item.label} className="flex items-center gap-2 text-sm text-white">
            <i className={`${item.icon} text-amber-400`} />
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
